import { Map as IMap } from 'immutable'
import {
  isSkipperGuidedReport,
  isSkipperReport,
  readDisplayMd
} from '@aytm/app/stats/page/sidebar/reports/lib/skipperGuidedReport'

const report = (props: Record<string, unknown>) => IMap({ type: 'skipper', ...props })

describe('isSkipperReport', () => {
  it('takes every skipper report, whatever its provenance', () => {
    expect(isSkipperReport(report({ origin: 'auto_launch' }))).toBe(true)
    expect(isSkipperReport(report({ origin: 'guided' }))).toBe(true)
    expect(isSkipperReport(report({}))).toBe(true)
  })

  it('leaves out non-skipper reports and absent ones', () => {
    expect(isSkipperReport(IMap({ type: 'concept' }))).toBe(false)
    expect(isSkipperReport(null)).toBe(false)
  })
})

describe('isSkipperGuidedReport', () => {
  it('files a report with a snapshot under guided', () => {
    expect(isSkipperGuidedReport(report({ guided_report: IMap({ generation_id: 'g1' }) }))).toBe(true)
  })

  // A failed generation drops the snapshot; the row is still a guided report.
  it('files a snapshot-less report with guided provenance under guided', () => {
    expect(isSkipperGuidedReport(report({ origin: 'guided' }))).toBe(true)
  })

  it('leaves only the auto-launched report out', () => {
    expect(isSkipperGuidedReport(report({ origin: 'auto_launch' }))).toBe(false)
    expect(isSkipperGuidedReport(report({}))).toBe(true)
  })

  it('ignores provenance on a non-skipper report', () => {
    expect(isSkipperGuidedReport(IMap({ type: 'concept', origin: 'guided' }))).toBe(false)
  })
})

describe('readDisplayMd', () => {
  it('reads display_md from the guided snapshot', () => {
    expect(readDisplayMd(report({ guided_report: IMap({ display_md: '## Objectives' }) }))).toBe('## Objectives')
  })

  it('returns an empty string when the report carries no display markdown', () => {
    expect(readDisplayMd(report({ guided_report: IMap({ generation_id: 'g1' }) }))).toBe('')
  })

  // the popup section reads the snapshot on provenance-blind rules, the auto-launched report included
  it('reads the auto-launched report the same way', () => {
    expect(readDisplayMd(report({ origin: 'auto_launch', guided_report: IMap({ display_md: '## X' }) }))).toBe('## X')
  })

  it('returns an empty string for a non-skipper report', () => {
    expect(readDisplayMd(IMap({ type: 'concept', guided_report: IMap({ display_md: '## X' }) }))).toBe('')
  })
})
